import {sendEvent} from '@optimaxdev/analytics/desktop/lib/dynamicYield/index';
import {SagaIterator} from 'redux-saga';
import {call, select, takeEvery} from 'redux-saga/effects';

import {CartItemType} from 'desktop/pages/cart/types';

import {createContext} from 'libs/dynamicYield/dynamicYieldResolvers';

import {getQuote, removeQuoteItem} from '../../reducers/quoteItems/quoteItems';
import {getQuoteItems} from '../../selectors';

// It is temporary solution
let isCartPageLoaded = false;

/**
 * Update Dynamic Yield context.
 *
 * @param {function(): SagaIterator} resolveContext - Context resolver.
 */
export function* updateContext(resolveContext: () => SagaIterator): SagaIterator {
    const context = yield call(resolveContext);
    yield call(sendEvent, 'spa', {context});
}

/**
 * Context resolver for Cart page.
 *
 * @returns {SagaIterator} - Dynamic Yield product context.
 */
export function* resolveContextForCart(): SagaIterator {
    const quoteItems = yield select(getQuoteItems);

    return yield call(
        createContext,
        'CART',
        quoteItems.map((item: CartItemType) => item.product_sku),
    );
}

/**
 * Set Dynamic Yield context for update Cart page.
 */
export function* updatedContextCartPage(): SagaIterator {
    // @ts-expect-error
    const isLoaded = yield isCartPageLoaded;
    if (isLoaded) {
        yield call(updateContext, resolveContextForCart);
    }
    isCartPageLoaded = true;
}

/**
 * Root Saga
 */
export default function* dynamicYieldSagaSPAContext(): SagaIterator {
    yield takeEvery(
        [`${getQuote.fulfilled}`, `${removeQuoteItem.fulfilled}`],
        updatedContextCartPage,
    );
}
